import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Rola a página para o topo em toda troca de rota, melhorando a experiência ao navegar por links.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
}
